module.exports = __webpack_public_path__ + "media/images/icons/envelope-9332c49286d04be59299dfd495d9605f.svg";